import {
  Component,
  ViewChild,
  ElementRef,
  OnDestroy,
  AfterViewInit,
  HostListener,
  input,
  output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FilterChipBaseModel } from './filter-chip-base.model';
import { environment } from '@environments/environment';

@Component({
  selector: 'cgw-filter-chip',
  standalone: true,
  imports: [MatButtonModule, CommonModule, MatIconModule],
  templateUrl: './filter-chip.component.html',
  styleUrl: './filter-chip.component.scss',
})
export class FilterChipComponent<T> implements OnDestroy, AfterViewInit {
  public readonly chips = input.required<FilterChipBaseModel<T>[]>();
  public readonly itemList = input.required<T>();
  public readonly iconsBaseUrl = input<string>(`${environment.apiImageStatic}/assets/logos/marcas`);

  public readonly onFilter = output<{ chip: FilterChipBaseModel<T>; list: T }>();

  public showArrowRight: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public showArrowLeft: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private resizeObserver: ResizeObserver;
  private scrollValue: number = 0;
  private filterSubscription$: Subscription;
  private isDragging: boolean = false;
  private startX: number = 0;
  private scrollLeft: number = 0;

  @ViewChild('scroll_container', { static: false }) scrollContainer: ElementRef;
  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent): void {
    this.isDragging = true;
    this.startX = event.touches[0].pageX - this.scrollContainer.nativeElement.offsetLeft;
    this.scrollLeft = this.scrollContainer.nativeElement.scrollLeft;
  }

  @HostListener('touchmove', ['$event'])
  onTouchMove(event: TouchEvent): void {
    if (!this.isDragging) return;
    const x = event.touches[0].pageX - this.scrollContainer.nativeElement.offsetLeft;
    const walk = (x - this.startX) * 1.5;
    this.scrollContainer.nativeElement.scrollLeft = this.scrollLeft - walk;

    const direction = x > this.startX ? 'left' : 'right';
    let offset = direction == 'right' ? 10 : -10;
    this.scrollValue = this.scrollContainer.nativeElement.scrollLeft + offset;
    this.scrollValue = this.scrollValue < 10 ? 0 : this.scrollValue;
    this.verifyArrows(this.scrollContainer.nativeElement);
  }

  @HostListener('touchend')
  onTouchEnd(): void {
    this.isDragging = false;
  }

  private verifyArrows(element): void {
    this.showArrowRight.next(element.scrollWidth > element.clientWidth);
    this.showArrowLeft.next(element.scrollWidth > element.clientWidth && this.scrollValue >= 100);
  }
  public ngAfterViewInit(): void {
    const element = this.scrollContainer.nativeElement;
    const resizeObserver = new ResizeObserver(() => {
      this.verifyArrows(element);
    });

    resizeObserver.observe(element);
    this.resizeObserver = resizeObserver;
  }

  public changeToTitle(chip: FilterChipBaseModel<T>): void {
    chip.icon = null;
  }

  public onClickChip(chip: FilterChipBaseModel<T>): void {
    // TODO: Implement with form to avoid loop on array
    this.chips().forEach((c) => {
      const active = chip.id == c.id;
      c.active = active;
      if (active)
        this.onFilter.emit({
          chip: c,
          list: c.filterFn(this.itemList()),
        });
    });
  }

  public scrollBar(direction: 'left' | 'right'): void {
    let offset = direction == 'right' ? 100 : -100;
    this.scrollValue = this.scrollContainer.nativeElement.scrollLeft + offset;
    this.scrollValue = this.scrollValue < 100 ? 0 : this.scrollValue;
    this.scrollContainer.nativeElement.scrollTo({
      left: this.scrollValue,
      behavior: 'smooth',
    });
    this.showArrowLeft.next(this.scrollValue >= 100);
  }

  public ngOnDestroy() {
    this.resizeObserver?.disconnect();
    this.filterSubscription$?.unsubscribe();
  }
}
